import React, { createContext, useContext, useEffect, useState } from 'react';
import { connectionDetector } from '@/services/connectionDetector';

interface ConnectionStatus {
  isOnline: boolean;
  lastChecked: Date;
  method: 'navigator' | 'ping' | 'timeout';
}

interface ConnectionContextType {
  isOnline: boolean;
  lastChecked: Date;
  method: 'navigator' | 'ping' | 'timeout';
  forceCheck: () => Promise<boolean>;
}

const ConnectionContext = createContext<ConnectionContextType | undefined>(undefined);

export const useConnection = (): ConnectionContextType => {
  const context = useContext(ConnectionContext);
  if (!context) {
    throw new Error('useConnection must be used within a ConnectionProvider');
  }
  return context;
};

interface ConnectionProviderProps {
  children: React.ReactNode;
}

export const ConnectionProvider: React.FC<ConnectionProviderProps> = ({ children }) => {
  const [status, setStatus] = useState<ConnectionStatus>(connectionDetector.getStatus());

  useEffect(() => {
    const removeListener = connectionDetector.addListener((newStatus) => {
      console.log('🔄 ConnectionContext - Nouveau statut:', newStatus);
      setStatus(newStatus);
    });
    return removeListener;
  }, []);

  const forceCheck = async (): Promise<boolean> => {
    return connectionDetector.forceCheck();
  };

  const value: ConnectionContextType = {
    isOnline: status.isOnline,
    lastChecked: status.lastChecked,
    method: status.method,
    forceCheck
  };

  return (
    <ConnectionContext.Provider value={value}>
      {children}
    </ConnectionContext.Provider>
  );
};
